import React, { useEffect, useEffectEvent, useRef } from 'react';
const styles = {"googleButton":"GoogleButton-module__googleButton__QE8Vl"};
/**
 * The place for "Continue with Google" (Sign in · C1, C3; Foundations · K-GoogleButton). The button itself is drawn by
 * its provider into this slot, so the slot owns only the size and the disabled state; it knows nothing about Google.
 */
export function GoogleButton({ theme, disabled, fullWidth, renderButton }) {
    const containerRef = useRef(null);
    const isDisabled = disabled === true;
    const fillContainer = useEffectEvent((container) => {
        container.replaceChildren();
        renderButton(container, { theme, width: Math.floor(container.clientWidth) });
    });
    useEffect(() => {
        const container = containerRef.current;
        if (container !== null) {
            fillContainer(container);
        }
        return () => {
            container?.replaceChildren();
        };
    }, [theme]);
    return (React.createElement("div", { ref: containerRef, className: styles.googleButton, "data-full-width": fullWidth === true, "data-disabled": isDisabled, "aria-disabled": isDisabled ? 'true' : undefined }));
}
//# sourceMappingURL=GoogleButton.js.map